import { InjectionToken } from '@angular/core';
export const TRANSLATE_FILE_DIRS = new InjectionToken<string[]>('Directories containing translation files');
